import { toDecimal, toThreeDecimals } from './helpers';

export default (price) => (price ? toThreeDecimals(toDecimal(price) + 1) : price);
